import { HttpResponse, HttpService } from '@application/http.service';
import type { PhysicalLocationApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class PhysicalLocationApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('receptions');
	}

	public getPhysicalLocation(physicalLocationId: number, receptionId: number): HttpResponse<PhysicalLocationApiModel> {
		return this.httpService.get(`${this.baseUri}/${receptionId}/PhysicalLocations/${physicalLocationId}`);
	}
}
